"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("../object/isNil"));

var BASE_HASH = 5178;
/**
 * Super simple hashing method that returns a number based on a string
 *
 * @param inputString - string to turn in to a hash
 * @param baseHash - based number to start on
 * @returns number based on input string
 */

var getHashFromString = function getHashFromString(inputString) {
  var baseHash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BASE_HASH;
  if ((0, _isNil["default"])(inputString)) return 0;
  var length = inputString.length;

  var _char;

  var hash = baseHash;

  for (var i = 0; i < length; i++) {
    _char = inputString.charCodeAt(i);
    hash = hash + _char;
  }

  return hash;
};

var _default = getHashFromString;
exports["default"] = _default;